import React, { useState, useLayoutEffect, useEffect } from "react"
import { connect } from "react-redux"

export const INCORRECT_EXTERNAL_PASSWORD = {
    title: "Incorrect Password",
    icon: "error",
    text: "Incorrect Password, please refresh and try again.",
    buttons: {
        confirm: {
            text: "Refresh",
            closeModal: false,
        }
    }
}

const ASK_FOR_PASSWORD_FOR_EXTERNAL_RESOURCE = {
    title: 'Password Required',
    text: `Please enter the password to view this.`,
    content: {
        element: 'input',
        attributes: {
            placeholder: "Password...",
            type: "password"
        }
    },
    buttons: {
        confirm: {
            text: "Submit",
            closeModal: true
        }
    },
    closeOnClickOutside: false,
    closeOnEsc: false,
}

/**
 * Helper to create a wrapper component that, if needed, based on the base_html, asks for the password before
 * attempting to mount the external resource, anf adjusts the "key" accordingly
 * @name getExternalPasswordWrapper
 * @function
 * @param {string} key - a string which functions as the param key to grab the id (such as "sheetId")
 * @param {React.Component} Component - a react component to be rendered once the password is accepted
 * @param {array<functions>} actionCreatorsToCallOnMount - optional array of action creators that need to be called once we successfully mount this (after pw)
 * @returns {React.Component} - mounted component, either the one passed to this function or nothing (if password hasnt been accepted)
 */
const getExternalPasswordWrapper = (key, Component, actionCreatorsToCallOnMount=[]) => props => {
    // an artifact of the initial implementation, we ask the base document, if we should ask for a password. Note: if
    // for some reason the user is able to edit the html prior to this running, the api endpoints will still return a 401
    const [needsPassword, _] = useState(document.getElementById("external-resource").classList.contains("password-protected"))
    const [receivedPassword, updateReceivedPassword] = useState(false)
    const [externalSlug, updateExternalSlug] = useState()
    // if there are auxilary action creators that need to be called here, lets keep track to just call them once
    const [hasCalledExtraAC, updateHasCalledAC] = useState(false)

    const askForPassword = async () => {
        if (needsPassword && !receivedPassword) {
            const password = await swal(ASK_FOR_PASSWORD_FOR_EXTERNAL_RESOURCE)

            updateReceivedPassword(true)
            updateExternalSlug(`${props.params[key]}-${btoa(password)}`)
        } else {
            updateExternalSlug(props.params[key])
        }
    }

    useLayoutEffect(() => {
        askForPassword()
    }, [])

    useEffect(() => {
        if (externalSlug && !hasCalledExtraAC) {
            actionCreatorsToCallOnMount.forEach(actionCreator => props[actionCreator](externalSlug))
            updateHasCalledAC(true)
        }
    }, [externalSlug])

    if (
        (receivedPassword || !needsPassword)
        && externalSlug
    ) {
        return <Component {...{[key]: externalSlug}} {...props} />
    } else {
        return <div></div>
    }
}

export default getExternalPasswordWrapper
